import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Currency } from '../_models/currency';

@Injectable()
export class CurrencyService {
   baseUrl = environment.apiUrl;

   constructor(private http: HttpClient) {}
   getCompanyCurrency(): Observable<Currency> {
      return this.http.get<Currency>(this.baseUrl + 'currency');
   }
}
